import React, { Component } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { Box, Button } from '@mui/material';
import moment from 'moment';
import i18n from '../../i18';
import { Day } from './Day';
import PropTypes from 'prop-types';
import { DateCalendar } from '@mui/x-date-pickers';
import { isEqual } from 'lodash';

const initialState = {
    startDate: null,
    endDate: null
};

export default class CustomCalendar extends Component {
    onChange = () => {};
    positionShortcut = 'bottom';
    constructor(props) {
        super(props);
        this.state = {
            firstCalendar: initialState,
            secondCalendar: initialState,
            shortcuts: props.shortcuts || []
            // shortcuts={[{ label: 'today', days: 1 }, { label: 'twoDays', days: 2 }]}
        };
        this.onChange = props.onChange;
        this.positionShortcut = props.positionShortcut || 'bottom';
    }

    componentDidMount() {
        const { startDate, endDate } = this.props.value;

        this.convertDateToCalendarRange(startDate, endDate);
    }
    componentDidUpdate(prevProps) {
        if (!isEqual(this.props.value, prevProps.value)) {
            const { startDate, endDate } = this.props.value;
            this.convertDateToCalendarRange(startDate, endDate);
        }
    }

    convertDateToCalendarRange = (startDate, endDate) => {
        const currentMonth = moment().month();
        const currentYear = moment().year();
        const startMonth = startDate ? startDate.month() : null;
        const startYear = startDate ? startDate.year() : null;
        const endMonth = endDate ? endDate.month() : null;
        const endYear = endDate ? endDate.year() : null;

        if (!startDate && !endDate) {
            return;
        }

        // If the start date is in the current month or earlier
        if (startMonth === endMonth && startYear === endYear) {
            if (
                startYear < currentYear ||
                (startYear === currentYear && startMonth <= currentMonth)
            ) {
                // If the start date is in the current month or earlier
                this.setState({
                    firstCalendar: { startDate, endDate },
                    secondCalendar: { ...initialState }
                });
            } else {
                // If the start date is in the future
                this.setState({
                    firstCalendar: { ...initialState },
                    secondCalendar: { startDate, endDate }
                });
            }
        }
        // If the start date is in the current month or earlier and the end date is in the future
        else if (
            !endMonth &&
            (startYear > currentYear ||
                (startYear === currentYear && startMonth > currentMonth))
        ) {
            // If the start date is in the current month or earlier and the end date is in the future
            this.setState({
                firstCalendar: { ...initialState },
                secondCalendar: { startDate, endDate }
            });
        } else {
            // If the start date is in the future
            this.setState({
                firstCalendar: { startDate, endDate: null },
                secondCalendar: { startDate: null, endDate }
            });
        }
    };

    handleDateChange = (newValue, calendarId) => {
        if (!newValue) {
            return;
        }
        const { firstCalendar, secondCalendar } = this.state;

        const selectedCalendar =
            calendarId === 'firstCalendar' ? firstCalendar : secondCalendar;
        const otherCalendar =
            calendarId === 'firstCalendar' ? secondCalendar : firstCalendar;

        // Check if the new date is before the start date of any calendar
        if (
            (selectedCalendar.startDate &&
                newValue.isBefore(selectedCalendar.startDate)) ||
            (otherCalendar.startDate &&
                newValue.isBefore(otherCalendar.startDate))
        ) {
            this.setState(
                {
                    [calendarId]: {
                        startDate: newValue,
                        endDate: null
                    },
                    [calendarId === 'firstCalendar'
                        ? 'secondCalendar'
                        : 'firstCalendar']: {
                        startDate: null,
                        endDate: null
                    }
                },
                this.handleUpdateDate
            );
            return;
        }
        // Check if the new date is after the end date of any calendar
        if (
            otherCalendar.startDate &&
            otherCalendar.endDate &&
            newValue.isAfter(otherCalendar.endDate)
        ) {
            this.setState(
                {
                    [calendarId]: {
                        startDate: null,
                        endDate: newValue
                    },
                    [calendarId === 'firstCalendar'
                        ? 'secondCalendar'
                        : 'firstCalendar']: {
                        startDate: otherCalendar.startDate,
                        endDate: null
                    }
                },
                this.handleUpdateDate
            );
            return;
        }

        const shouldSetEndDate =
            (!otherCalendar.endDate && otherCalendar.startDate) ||
            selectedCalendar.startDate ||
            (otherCalendar.startDate && otherCalendar.endDate < newValue);
        const shouldSetStartDate =
            !otherCalendar.startDate && !selectedCalendar.startDate;

        const newCalendarState = {
            ...selectedCalendar,
            startDate: shouldSetStartDate
                ? newValue
                : selectedCalendar.startDate,
            endDate: shouldSetEndDate ? newValue : selectedCalendar.endDate
        };
        this.setState(
            {
                [calendarId]: newCalendarState
            },
            this.handleUpdateDate
        );
    };

    handleUpdateDate = () => {
        const { firstCalendar, secondCalendar } = this.state;
        let startDate = null;
        let endDate = null;

        startDate = firstCalendar.startDate || secondCalendar.startDate;
        endDate = firstCalendar.endDate || secondCalendar.endDate;

        this.onChange({ startDate, endDate });
    };

    handleShortcutClick = (days) => {
        // Set the start date to the current date minus the number of days, but if days is 1, set the end date to the current date
        const startDate = moment()
            .subtract(days - 1, 'days')
            .startOf('day');
        const endDate = moment();

        let firstCalendar = { startDate, endDate };
        let secondCalendar = { ...initialState };

        if (startDate.month() !== endDate.month()) {
            firstCalendar = {
                startDate,
                endDate: null
            };
            secondCalendar = {
                startDate: null,
                endDate: endDate
            };
        }

        this.setState({
            firstCalendar,
            secondCalendar
        });

        this.onChange({ startDate, endDate });
    };
    handleClear = () => {
        this.setState({
            firstCalendar: initialState,
            secondCalendar: initialState
        });
        this.onChange({ startDate: null, endDate: null });
    };

    renderShortcuts = () => {
        return (
            this.state.shortcuts &&
            this.state.shortcuts.length > 0 && (
                <Box
                    width="100%"
                    gap={1}
                    p={1}
                    display="flex"
                    justifyContent="space-between"
                >
                    {this.state.shortcuts.map((shortcut) => (
                        <Button
                            key={shortcut.days}
                            sx={{ flexGrow: 1, fontSize: '0.8rem', p: '5px' }}
                            variant="outlined"
                            onClick={() =>
                                this.handleShortcutClick(shortcut.days)
                            }
                        >
                            {i18n.t(`shortcuts.${shortcut.label}`)}
                        </Button>
                    ))}
                    {/*<Button variant="outlined" onClick={this.handleClear}>*/}
                    {/*    {i18n.t('shortcuts.clear')}*/}
                    {/*</Button>*/}
                </Box>
            )
        );
    };

    render() {
        const { firstCalendar, secondCalendar } = this.state;

        const locale = i18n.language === 'en' ? 'en-gb' : i18n.language;
        const nextMonth = moment().add(1, 'months').startOf('month');

        // Props for the Day component
        const firstDayProps = {
            startDate: firstCalendar.startDate,
            endDate:
                secondCalendar.endDate && !secondCalendar.startDate
                    ? secondCalendar.endDate
                    : firstCalendar.endDate
        };
        const secondDayProps = {
            startDate:
                firstCalendar.startDate && !firstCalendar.endDate
                    ? firstCalendar.startDate
                    : secondCalendar.startDate,
            endDate: secondCalendar.endDate
        };

        return (
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                m={0}
                p={0}
            >
                {this.positionShortcut === 'top' && this.renderShortcuts()}
                <Box display="flex" flexDirection="column" m={0} p={0}>
                    <LocalizationProvider
                        dateAdapter={AdapterMoment}
                        adapterLocale={locale}
                    >
                        <DateCalendar
                            margin="none"
                            id="firstCalendar"
                            disabled={this.props.disabled}
                            showDaysOutsideCurrentMonth
                            value={firstCalendar.startDate}
                            onChange={(nv) =>
                                this.handleDateChange(nv, 'firstCalendar')
                            }
                            slots={{ day: Day }}
                            slotProps={{
                                day: () => firstDayProps
                            }}
                        />
                        <DateCalendar
                            margin="none"
                            id="secondCalendar"
                            disabled={this.disabled}
                            showDaysOutsideCurrentMonth
                            value={secondCalendar.startDate}
                            defaultCalendarMonth={nextMonth}
                            onChange={(nv) =>
                                this.handleDateChange(nv, 'secondCalendar')
                            }
                            slots={{ day: Day }}
                            slotProps={{
                                day: () => secondDayProps
                            }}
                        />
                    </LocalizationProvider>
                </Box>
                {this.positionShortcut === 'bottom' && this.renderShortcuts()}
            </Box>
        );
    }
}
CustomCalendar.propTypes = {
    value: PropTypes.shape({
        startDate: PropTypes.any,
        endDate: PropTypes.any
    }),
    onChange: PropTypes.func.isRequired,
    shortcuts: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            days: PropTypes.number
        })
    ),
    positionShortcut: PropTypes.oneOf(['top', 'bottom'])
};
